import { render, staticRenderFns } from "./writingselection.vue?vue&type=template&id=f33f512a&scoped=true&"
import script from "./writingselection.vue?vue&type=script&lang=js&"
export * from "./writingselection.vue?vue&type=script&lang=js&"
import style0 from "./writingselection.vue?vue&type=style&index=0&id=f33f512a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f512a",
  null
  
)

export default component.exports